// Tier-2 <Popconfirm> backed by AntD Popconfirm (FORT-331). A confirm bubble
// anchored to its child trigger. The `danger` flag maps to AntD's danger OK
// button (its colour comes from the token-sourced theme), so no useTokens() here.
import React from 'react';
import { Popconfirm as AntPopconfirm } from 'antd';
import type { CommonProps } from './types';

export interface PopconfirmProps extends CommonProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  onConfirm?: () => void;
  onCancel?: () => void;
  okText?: React.ReactNode;
  cancelText?: React.ReactNode;
  /** Style the confirm button as destructive. */
  danger?: boolean;
  disabled?: boolean;
  /** The element(s) that open the confirm bubble when clicked. */
  children: React.ReactNode;
}

export const Popconfirm: React.FC<PopconfirmProps> = ({
  title,
  description,
  onConfirm,
  onCancel,
  okText,
  cancelText,
  danger,
  disabled,
  children,
  className,
  style,
  'data-testid': dataTestId,
}) => (
  // AntD anchors the confirm bubble to its child and doesn't forward arbitrary DOM
  // attrs, so wrap the trigger in a span that carries className/style/data-testid
  // (honours CommonProps and gives a stable Playwright selector).
  <AntPopconfirm
    title={title}
    description={description}
    onConfirm={onConfirm}
    onCancel={onCancel}
    okText={okText}
    cancelText={cancelText}
    okButtonProps={danger ? { danger: true } : undefined}
    disabled={disabled}
  >
    <span className={className} style={style} data-testid={dataTestId}>
      {children}
    </span>
  </AntPopconfirm>
);
